module.exports = __webpack_public_path__ + "static/media/CAMO_Final_Logo.b9e9208b.svg";